var render = function render(){var _vm=this,_c=_vm._self._c;return _c('checkbox',{staticClass:"justify-center",attrs:{"checked":_vm.item[_vm.field]},on:{"value":_vm.onChange}},[_c('div',{staticClass:"ml-2 text-xs"},[_vm._v("отправлен")])])
}
var staticRenderFns = []

export { render, staticRenderFns }